import React, { Component, Fragment } from 'react';
import { Grid, withStyles, Button, Typography, Backdrop, IconButton, TextField, useMediaQuery } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { useStyles } from './common/useStyles';
import './common/Common.css'
import api from './common/APIValues';
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import InfoIcon from '@material-ui/icons/InfoOutlined';
import CommonFunc from './common/CommonFunc';
import axios from 'axios';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import EDWhatLogoIcon from './images/EdWhat-01-01.png';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import routeService from '../services/Routing';
import constant from '../components/common/Constants';

const withMediaQuery = (...args) => Component => props => {
    const mediaQuery = useMediaQuery(...args);    
    return <Component mediaQuery={mediaQuery} {...props} />;
};

class AddAssignment extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            loader: false,
            assignment_title: '', assignment_desc: '', err_msg: '',
            fileType: null, fileName: null, fileBase64String: null, preViewImage: null,
            errors: {
                assignment_title: '',
                assignment_desc: '',
                assignment_image: '',
            },
            anchorEl: null,
        }
    }

    componentDidMount() {
        if(!this.props.userEmail) {
            routeService.routePage(this.props, constant.home);
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });   
    }

    componentDidUpdate = (prevProps, prevState) => {
        if(this.props.searchValue !== prevProps.searchValue) {
            routeService.routePage(this.props, constant.home);
        }
    }

    handleChangeCKEditor = (e, editor) => {
        let data = editor.getData();
        let errors = this.state.errors;
        errors.assignment_desc = data.length <= 0 ? 'Please enter assignment description' : '';
        this.setState({ errors: errors, assignment_desc: data });
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;

        switch (name) {
            case 'assignment_title':
                errors.assignment_title = value.length <= 0 ? 'Please enter assignment title' : '';
                break;
            case 'assignment_desc':
                errors.assignment_desc = value.length <= 0 ? 'Please enter assignment description' : '';
                break;
            default:
                break;
        }
        this.setState({ errors, [name]: value });
    }

    isPdfFile(fileName) {
        if (fileName) {
            const parts = fileName.split('.');
            return parts.length > 1 && parts.pop().toLowerCase() === 'pdf';
        }
        else
            return false;
    }
    
    validateInputs() 
    {
        let validationResult = "";
        if (!this.state.assignment_title) {
            validationResult = "No title provided";
        }
    
        if (!this.state.assignment_desc) {
            validationResult = "No description provided";
        }
    
        if (this.state.fileName) {
            const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
    
            if (!validFileTypes.includes(this.state.fileType)) {
                validationResult = "Invalid file type. Allowed types are jpeg, jpg, png, gif, pdf";
            }
    
            if (this.state.fileSize >= 5 * 1024 * 1024) {
                validationResult = "File size exceeds 5 MB";
            }
        }
        if(validationResult !== "") {
            alert(`Error: ${validationResult}`);
        }
        else
            return true;
    };

    createAssignment = () => {        
        if (CommonFunc.validateForm(this.state.errors) && this.validateInputs()) {
            this.setState({ loader: true });
            const originName = window.location.origin.replace('www.', '');
            let groupId = this.props.match.params.groupId ? this.props.match.params.groupId : -1;
            let rowData = {
                ASSIGNMENT_TITLE: this.state.assignment_title,
                ASSIGNMENT_DESC: this.state.assignment_desc,
                ASSIGNMENT_FILE_NM: this.state.fileName,
                ASSIGNMENT_CREATE_USER_ID: this.props.userEmail,
                ENV: api.env,
                GROUP_ID: Number(groupId),
                ORIGIN_NM: originName,
                ASSIGNMENT_FILE_BASE_64_STRNG: this.state.fileBase64String,
            }

            axios({
                method: 'post',
                url: api.partialURL + 'AddAssignment/CreateUserAssignment',
                data: JSON.stringify(rowData),
                headers: { 'Content-Type': 'application/json' },
                mode: 'cors',
            })
            .then(res => {
                if(res) {
                    this.setState({ loader: false });
                    if (res.data.result === 'success') {
                        let pathName = constant.assignmentDetails + res.data.assignmentId;
                        routeService.routePage(this.props, pathName);
                    } else {
                        this.setState({ err_msg: res.data.result });
                    }
                }
            })
            .catch(function (response) {
                this.setState({ err_msg: response, loader: false });
            });
        } else {
            let errors = this.state.errors;
            if (!this.state.assignment_title) {
                errors.assignment_title = 'Please enter assignment title';
            }            
            if (!this.state.assignment_desc) {
                errors.assignment_desc = 'Please enter assignment description';
            }
            if(this.state.fileName && (this.state.fileType !== 'image/jpeg' || this.state.fileType !== 'image/jpg' ||
                this.state.fileType !== 'image/png' || this.state.fileType !== 'image/gif')) {
                errors.assignment_image = 'This file format is not supported';
            } else {
                errors.assignment_image = '';
            }
            this.setState({ errors });
        }
    }

    onFileUploadChange = (event) => {
        var file = event.target.files[0];
        if(file) {
            if (this.isPdfFile(file.name) ) {
                this.state.preViewImage = file.name;
            }
            else {
                this.setState({ preViewImage: URL.createObjectURL(file) });
            }
            var blob = file.slice();
            var reader = new FileReader();

            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var cont = evt.target.result
                    var base64String = CommonFunc.getB64Str(cont);

                    this.setState ({
                        fileType: file.type,
                        fileBase64String: base64String,
                        fileName: file.name,
                        fileSize: file.size
                    });
                }
            }.bind(this);

            reader.readAsArrayBuffer(blob);
        } else {
            this.setState ({
                fileType: null,
                fileBase64String: null,
                fileName: null
            });
        }
    }

    closeImageIcon = () => {
        this.setState({ preViewImage: false });
    }

    render() {
        const { classes, mediaQuery } = this.props;
        const col26 = mediaQuery ? 2 : 6;
        const col106 = mediaQuery ? 10 : 6;
        const col1 = mediaQuery ? 2 : 1;
        const col211 = mediaQuery ? 2 : 11;
        const buttonLeftIcon = classNames(classes.iconMedSize, classes.leftIcon);
        const open = Boolean(this.state.anchorEl);

        return (
            <Fragment>
                <Backdrop className={classes.backdrop} open={this.state.loader}>
                    <img src={EDWhatLogoIcon} height={50} alt="Logo" />
                </Backdrop>

                <Grid container spacing={0} style={{ marginTop: mediaQuery ? '55px' : '90px' }}>
                    <Grid item xs={ !mediaQuery ? 1 : 0}>
                        <InfoIcon className={buttonLeftIcon} />
                    </Grid>
                    <Grid item xs={!mediaQuery ? 11 : 0}>
                        <Typography className={classes.titleInfo} color="textSecondary">                            
                            Please mind your language. Try to keep it short and to the point. Make sure it is education related.
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container spacing={2} style={{ marginTop: '10px' }}>
                    <Grid item xs={12}>
                        <TextField fullWidth name="assignment_title" label="Type assignment title here" required
                            onChange={this.handleChange} noValidate value={this.state.assignment_title} size="small"
                            variant="outlined" style={{ backgroundColor: '#e7e7e7' }} />
                        { this.state.errors.assignment_title.length > 0 && 
                            <span className='error'>{this.state.errors.assignment_title}</span> }
                    </Grid>                    
                    <Grid item xs={12}>
                        <CKEditor 
                            size="small"
                            editor={ClassicEditor} 
                            data={this.state.assignment_desc} 
                            onChange={this.handleChangeCKEditor}
                            config={{
                                toolbar: [
                                    "heading",
                                    "|",
                                    "bold",
                                    "italic",
                                    "underline",
                                    "bulletedList",
                                    "numberedList",
                                    "blockQuote",
                                    "link",
                                    "mediaEmbed",
                                    "|",
                                    "undo",
                                    "redo",
                                ],
                                placeholder: "Type assignment description here *",
                            }}
                        />
                        { this.state.errors.assignment_desc.length > 0 && 
                            <span className='error'>{this.state.errors.assignment_desc}</span> }
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.subTitle11} color="textSecondary">
                            Upload image (.jpeg | .png | .jpg | .gif | .pdf)
                        </Typography>
                    </Grid>
                    <Grid item xs={col106}>                           
                        <label htmlFor="assignment_image">
                            <input
                                style={{ display: "none" }}
                                id="assignment_image"
                                name="assignment_image"
                                type="file"
                                onChange={ e => {this.onFileUploadChange(e)}}
                            />
                            <Button color="secondary" className={classes.customButtonError} 
                                variant="contained" component="span" size="small">
                                Choose File
                            </Button>
                        </label>
                    </Grid>
                    <Grid item xs={col26}>
                        <Button fullWidth variant="contained" color="primary" className={classes.customButtonFocus}
                            onClick={this.createAssignment} size="small">
                                Create Assignment
                        </Button>                        
                    </Grid>                  
                </Grid>
                
                { this.state.preViewImage && !this.isPdfFile(this.state.preViewImage) &&
                    <Grid container spacing={0} style={{ marginTop: '10px' }}>                        
                        <Grid item xs={col211}>
                            <img src={this.state.preViewImage} style={{width: '100%'}}
                                alt="pre-view image" />
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton style={{marginTop: '-18px', marginLeft: '-10px'}} onClick={this.closeImageIcon} 
                                aria-label="settings">
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                }
                
                { this.state.preViewImage && this.isPdfFile(this.state.preViewImage) &&
                    <Grid container spacing={0} style={{ marginTop: '10px' }}>                        
                        <Grid item xs={col211}>
                            <PictureAsPdfIcon/>
                            {this.state.preViewImage}
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton style={{marginTop: '-18px', marginLeft: '-10px'}} onClick={this.closeImageIcon} 
                                aria-label="settings">
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                }
                <Grid container spacing={col1} style={{ marginTop: '5px' }}>
                    <Grid item xs={12}>
                        { this.state.err_msg.length > 0 && <span className='error'>{this.state.err_msg}</span> }
                    </Grid>
                </Grid>
            </Fragment>
        );
    }
}

export default withRouter(withStyles(useStyles)(withMediaQuery('(min-width:600px)')(AddAssignment)))